import React from 'react';
import { cn } from '@/utils/tailwind';

type LayoutTableControllerProps = {
  children: React.ReactNode;
  noPX?: boolean;
  className?: string;
};

const LayoutTableController = ({
  children,

  className,
}: LayoutTableControllerProps) => {
  return (
    <div className={cn('grid h-[80px] gap-[20px]', 'px-[20px]', className)}>
      <div className="scrollbar flex h-[80px] w-full justify-between gap-[20px] overflow-x-auto">
        {children}
      </div>
    </div>
  );
};

export default LayoutTableController;
